export const OPTION_LIST_CONFIGURATIONS = [
    'OPTION_ONLY',
    'OPTION_AND_MANUFACTURING'
];
export const PRODUCT_LIST_CONFIGURATIONS = ['ITEM_ONLY'];
export const MANUFACTURING_LIST_CONFIGURATIONS = [
    'MANUFACTURING',
    'OPTION_AND_MANUFACTURING'
];
export function optionConfigurationFromToggle(alsoManufacturing) {
    return alsoManufacturing ? 'OPTION_AND_MANUFACTURING' : 'OPTION_ONLY';
}
export function isOptionLike(value) {
    return (value === 'OPTIONNABLE' ||
        value === 'OPTION_ONLY' ||
        value === 'OPTION_AND_MANUFACTURING');
}
export function isOptionAndManufacturing(value) {
    return value === 'OPTION_AND_MANUFACTURING';
}
/** A manufacturing catalog element. An option listed in manufacturing stays an option. */
export function isManufacturingOnly(value) {
    return value === 'MANUFACTURING';
}
export function tracksQuantity(saleItem) {
    return (saleItem === null || saleItem === void 0 ? void 0 : saleItem.trackQuantity) !== false;
}
